import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const OmniQueueIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} width="20px" height="20px" viewBox="0 0 20 20">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="Omni-queue-icon"
                transform="translate(-119.000000, -326.000000)"
            >
                <g
                    id="-g--omni-queue-24px"
                    transform="translate(117.000000, 324.000000)"
                >
                    <rect id="Rectangle" x="0" y="0" width="24" height="24" />
                    <polygon
                        id="Path"
                        fill="currentColor"
                        points="13.79 8 15.59 5 13.79 2 10.21 2 8.41 5 10.21 8"
                    />
                    <polygon
                        id="Path"
                        fill="currentColor"
                        points="16.45 11.51 20.04 11.51 21.83 8.51 20.04 5.51 16.45 5.51 14.65 8.51"
                    />
                    <polygon
                        id="Path"
                        fill="currentColor"
                        points="20.04 12.51 16.45 12.51 14.65 15.51 16.45 18.51 20.04 18.51 21.83 15.51"
                    />
                    <polygon
                        id="Path"
                        fill="currentColor"
                        points="7.55 11.51 9.35 8.51 7.55 5.51 3.96 5.51 2.17 8.51 3.96 11.51"
                    />
                    <polygon
                        id="Path"
                        fill="currentColor"
                        points="7.55 12.51 3.96 12.51 2.17 15.51 3.96 18.51 7.55 18.51 9.35 15.51"
                    />
                    <polygon
                        id="Path"
                        fill="currentColor"
                        points="10.21 16 8.41 19 10.21 22 13.79 22 15.59 19 13.79 16"
                    />
                </g>
            </g>
        </g>
    </SvgIcon>
);

export default OmniQueueIcon;
